import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse } from '@models/response.model';
import { NotificationEndpoints } from '@core/constants/endpoints.const';
import { UserType } from '@medicalapp/shared-core';

export interface IModuleNotificationModel {
  moduleName: string;
  notificationCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly http = inject(HttpClient);

  getModuleNotificationCount = (
    userType: UserType,
    patientId: string,
    moduleName: string
  ) => {
    return this.http.get<ApiResponse<IModuleNotificationModel[]>>(
      `${NotificationEndpoints.ModuleNotificationsCount}?usertype=${userType}&patientId=${patientId}&moduleName=${moduleName}`
    );
  };
}
